import { useState, useCallback } from 'react';
import api from '../services/api';

export function useICPendingQueue() {
  const [queue, setQueue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processedCount, setProcessedCount] = useState(0);

  const loadPending = useCallback(async () => {
    setLoading(true);
    setProcessedCount(0);
    try {
      const data = await api.get('/notes/pending-ic');
      setQueue(Array.isArray(data?.pending) ? data.pending : []);
    } catch (err) {
      console.error('[useICPendingQueue] loadPending error:', err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const confirmCurrent = useCallback(async (icon) => {
    const current = queue[0];
    if (!current) return;

    setLoading(true);
    try {
      await api.post(`/notes/${current.note_id}/confirm-ic`, { icon });
      setQueue(prev => prev.slice(1));
      setProcessedCount(c => c + 1);
    } catch (err) {
      if (err.response?.status === 409) {
        setQueue(prev => prev.slice(1));
        setProcessedCount(c => c + 1);
      } else {
        throw err;
      }
    } finally {
      setLoading(false);
    }
  }, [queue]);

  const enqueueAfterNoteSave = useCallback((noteId, contactInfo) => {
    setQueue(prev => [
      ...prev,
      {
        note_id: noteId,
        phone: contactInfo.phone,
        contact_name: contactInfo.contact_name || contactInfo.phone,
        current_icon: contactInfo.current_icon || null,
        saved_at: new Date().toISOString(),
      },
    ]);
  }, []);

  return {
    currentPending: queue[0] || null,
    currentIndex: queue.length > 0 ? processedCount + 1 : 0,
    totalCount: processedCount + queue.length,
    loading,
    loadPending,
    confirmCurrent,
    enqueueAfterNoteSave,
  };
}
